import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import AutoScrollPlugin from '../plugins/AutoScrollPlugin';
import TransposePlugin from '../plugins/TransposePlugin';
import FontSizePlugin from '../plugins/FontSizePlugin';
import HideChordsPlugin from '../plugins/HideChordsPlugin';
import OverviewPlugin from '../plugins/OverviewPlugin';
import MetronomePlugin from '../plugins/MetronomePlugin';
import ContinuousViewPlugin from '../plugins/ContinuousViewPlugin';
import ExportPlugin from '../plugins/ExportPlugin';

import './ViewSongPlugins.scss';

const ViewSongPlugins = ({
  hideChords,
  setHideChords,
  overview,
  setOverview,
  song,
  service,
  continuousView,
  setContinuousView,
  onManualTranspose,
  currentSongIndex,
}) => {
  const [target, setTarget] = useState('view-body');

  // In continuous view, target only the first song section
  useEffect(() => {
    if (continuousView) {
      setTarget('song-section-0');
    } else {
      setTarget('view-body');
    }
  }, [continuousView]);

  return (
    <div className="ViewSongPlugins horizontal-menu">
      <AutoScrollPlugin song={song} />
      <MetronomePlugin song={song} />
      <TransposePlugin target={target} onManualTranspose={onManualTranspose} songIndex={currentSongIndex} />
      <FontSizePlugin target={target} />
      <HideChordsPlugin hideChords={hideChords} setHideChords={setHideChords} />
      <OverviewPlugin overview={overview} setOverview={setOverview} />
      {service && <ContinuousViewPlugin continuousView={continuousView} setContinuousView={setContinuousView} />}
      <ExportPlugin song={song} />
    </div>
  );
};

ViewSongPlugins.propTypes = {
  hideChords: PropTypes.bool,
  setHideChords: PropTypes.func,
  overview: PropTypes.bool,
  setOverview: PropTypes.func,
  song: PropTypes.object.isRequired,
  service: PropTypes.object,
  continuousView: PropTypes.bool,
  setContinuousView: PropTypes.func,
  onManualTranspose: PropTypes.func,
  currentSongIndex: PropTypes.number,
};

export default ViewSongPlugins;
